import React, { useEffect, useState, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import styles from './index.module.scss';
import Button from '@material-ui/core/Button';

const TRANSITION_MS = 225;

const AnnotationWrapDialog = ({
  open,
  onClose,
  className,
  classes = {},
  BackdropProps = {},
  disableBackdropClick = false,
  disableEscapeKeyDown = false,
  external = false,
  children,
  ...rest
}) => {
  const [mounted, setMounted] = useState(false);
  const [active, setActive] = useState(false);
  const rafRef = useRef();
  const timerRef = useRef();

  useEffect(() => {
    if (open) {
      clearTimeout(timerRef.current);
      setMounted(true);
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = requestAnimationFrame(() => setActive(true));
      });
    } else {
      setActive(false);
      timerRef.current = setTimeout(() => setMounted(false), TRANSITION_MS);
    }
    return () => cancelAnimationFrame(rafRef.current);
  }, [open]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  // Esc 關閉
  useEffect(() => {
    if (!mounted) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape' && !disableEscapeKeyDown) {
        onClose && onClose(e, 'escapeKeyDown');
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [mounted, disableEscapeKeyDown, onClose]);

  // 鎖住 body 捲動
  useEffect(() => {
    if (!mounted) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mounted]);

  const handleContainerClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget && !disableBackdropClick) {
        onClose && onClose(e, 'backdropClick');
      }
    },
    [disableBackdropClick, onClose]
  );

  if (!mounted) return null;

  return ReactDOM.createPortal(
    <div className={classnames(styles.root, { [styles.active]: active }, className, classes.root)}>
      <div className={classnames(styles.backdrop, classes.backdrop)} style={BackdropProps.style} />
      {external ? (
        <span className={styles.logoLink}>
          <img className={styles.logo} src="/img/logo.svg" alt="logo" />
        </span>
      ) : (
        <a href="/bookshelf" className={styles.logoLink}>
          <img className={styles.logo} src="/img/logo.svg" alt="logo" />
        </a>
      )}
      <div
        className={classnames(styles.container, classes.container, classes.scrollPaper)}
        onClick={handleContainerClick}
      >
        <div className={classnames(styles.paper, styles.content)} role="dialog" aria-modal="true" {...rest}>
          {!external && (
            <div className={classnames(classes.paper, styles.paper, styles.btnwrapper)}>
              <Button
                size="large"
                variant="outlined"
                className={styles.backBtn}
                onClick={onClose}
              >
                <img src="/img/annotationArrowLeft.svg" alt="返回書櫃" />
                返回書櫃
              </Button>
            </div>
          )}
          <div className={classes.paper}>
            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AnnotationWrapDialog;
